import { useState } from 'react'
import { ImageKit, AppLayout, Container } from '@components'
import { NextPage } from 'next'
import { usersData } from '../../conference_page_data'
import Slider from '@ant-design/react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import FsLightBox from 'fslightbox-react'
import { NextSeo } from 'next-seo'

const Conference: NextPage<{}> = () => {
  const [videoPopupToggler, setVideoPopupToggler] = useState<boolean>(false)
  const [videoPopupURL, setVideoPopupURL] = useState<string>('')

  const openVideoPopup = (videoURL: string) => {
    setVideoPopupToggler(!videoPopupToggler)
    setVideoPopupURL(videoURL)
  }

  return (
    <AppLayout>
      <NextSeo
        title="Technology and Innovation Summit"
        description="Watch talks from our Technology and Innovation Summit speakers"
        canonical="https://www.marketxventures.com/conference"
      />
      <Container>
        <FsLightBox toggler={videoPopupToggler} sources={[videoPopupURL]} />
        <div className="m-auto max-w-[1080px]">
          {/* Top Heading Section */}
          <div className="mt-4 flex px-4">
            <span className="mb-2.5 text-[1.6rem] font-bold leading-8">
              Technology and Innovation Summit
            </span>
          </div>
          {/* End - Top Heading */}

          {/* Talks Section */}
          <div className="mt-4 flex md:px-4">
            <span className="text-lg font-semibold uppercase text-primary">
              talks
            </span>
          </div>
          {/* End - Talks */}

          {/* Cards Section */}
          {usersData.map((item: any) => (
            <div key={item.id} className="pb-12">
              <div className="mt-4 flex md:px-4">
                <div className="cursor-pointer rounded-lg border border-[#f0f0f0] transition-all duration-500 hover:shadow-xl">
                  <div className="p-3">
                    <div className="grid grid-cols-1 gap-2.5 p-2 md:grid-cols-3">
                      <div className="col-span-2 flex flex-col">
                        <span className="mb-2.5 text-xl font-bold">
                          {item.stack}
                        </span>
                        <p className="mb-4 max-h-52 overflow-hidden text-ellipsis text-[15px] leading-loose">
                          {item.details}
                        </p>
                      </div>
                      <div>
                        {item.talksGroup && (
                          <div className="mb-4 w-full">
                            {/* @ts-ignore */}
                            <Slider
                              className="w-full"
                              infinite
                              speed={500}
                              slidesToShow={1}
                              slidesToScroll={1}
                              autoplay
                              fade
                              dots={false}>
                              {item.talksGroup.map((media: any) => {
                                return (
                                  <div
                                    key={media.id}
                                    className="flex justify-center">
                                    <div className="relative mx-auto h-[16.18rem] max-h-[210px] w-[20.56rem] max-w-[220px] overflow-hidden rounded-lg">
                                      <ImageKit
                                        src={media.img}
                                        alt="first image"
                                        fill
                                        style={{ objectFit: 'cover' }}
                                        placeholder="blur"
                                        blurDataURL={media.img}
                                      />

                                      <div className="absolute bottom-0 w-full bg-gradient-to-t from-[#000000d4] to-[#00000000] px-2.5 pb-2.5 pt-7 leading-5">
                                        <span className="text-[14px] font-semibold tracking-[1px] text-white">
                                          {media.name}
                                        </span>{' '}
                                        <br />
                                        <span className="text-[10px] text-white">
                                          {media.position}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </Slider>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="mb-4 ml-4 flex cursor-pointer items-center gap-2.5 text-[#4364e7]"
                      onClick={() => openVideoPopup(item.videoURL)}>
                      <span className="text-[2rem]">
                        <svg
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="play-circle"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true">
                          <path
                            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                            fill="#1890ff"></path>
                          <path
                            d="M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 01-12.7-6.5V353a8 8 0 0112.7-6.5l218.4 158.8a7.9 7.9 0 010 12.9z"
                            fill="#e6f7ff"></path>
                          <path
                            d="M676.1 505.3L457.7 346.5A8 8 0 00445 353v317.6a8.02 8.02 0 0012.7 6.5l218.4-158.9a7.9 7.9 0 000-12.9z"
                            fill="#1890ff"></path>
                        </svg>
                      </span>
                      <span className="text-sm">View talk</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {/* End - Cards Section */}
        </div>
      </Container>
    </AppLayout>
  )
}

export default Conference
